var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIPhoneOld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.007 24.3c0 1.62 1.132 2.7 2.824 2.7h6.345C20.868 27 22 25.92 22 24.3V7.7C22 6.08 20.868 5 19.176 5h-6.345c-1.692 0-2.824 1.08-2.824 2.7zm1.671-.821V8.52h8.65V23.48zM14 6.809c0-.21.17-.38.38-.38h3.24a.38.38 0 1 1 0 .759h-3.24a.38.38 0 0 1-.38-.38zm1.912 17.365a.912.912 0 1 0 0 1.823.912.912 0 0 0 0-1.823zM18.88 6.428a.38.38 0 1 0 0 .76.38.38 0 0 0 0-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.808c0-.21.17-.38.38-.38h3.24a.38.38 0 1 1 0 .76h-3.24a.38.38 0 0 1-.38-.38z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIPhoneOld);
export default __webpack_public_path__ + "static/media/Mobile_iPhone-Old.e7a3df27517f761b7a8cdc61cd0a3cd2.svg";
export { ForwardRef as ReactComponent };